module.exports = __webpack_public_path__ + "img/spicesSmall.003b92ef.jpg";